import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setEducationDataActions,
  setPreviousDataFetchActions,
  setEducationDatacreateActions,
  SetActiveTabs,
  setEducationDataPutActions,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/FormDetails/EducationDetails.scss";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Select from "react-select";
import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import { makeStyles } from "@mui/styles";
import { toast } from "react-toastify";
import ReactCrop from "react-image-crop";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import pdfIcon from "../../../Assets/pdf.png";
import excelIcon from "../../../Assets/excelIcon.png";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const EducationDetails = () => {
  const state = useSelector((state) => state);
  const [formDirty, setFormDirty] = useState(false);
  const dispatch = useDispatch();

  const [fileUrl, setfileUrl] = useState("");
  const [file, setFile] = useState();
  const [updateStatus, setUpdateStatus] = useState(
    // state.EducationAction.EducationData != undefined &&
    //   state.EducationAction.EducationData != null
    //   ? state.EducationAction.EducationData.not_studied
    //   : false
    false,
  );
  const formData = new FormData();
  const [PresentUrls, setPresentUrls] = useState([]);

  const [Educatiobnfiles, setEducationFiles] = useState();

  const [images, setImages] = useState([null, null, null, null, null, null]);
  const [Presentimages, setPresentImages] = useState([
    null,
    null,
    null,
    null,
    null,
  ]);

  const [imagesFile, setImagesFile] = useState([null, null, null, null, null]);

  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );

  const isAthena =
    organization?.organization?.id === "28e108e0-a644-4365-89df-317867f00f22";

  const initialState = {
    sslc_school_name: "",
    sslc_school_place: "",
    sslc_year_of_passing: "",
    hsc_school_name: "",
    hsc_school_place: "",
    hsc_year_of_passing: "",
    ug_school_name: "",
    ug_school_place: "",
    ug_year_of_passing: "",
    ug_course_name: "",
    ug_branch_name: "",
    diploma_school_name: "",
    diploma_school_place: "",
    diploma_year_of_passing: "",
    diploma_branch_name: "",
    diploma_course_name: "",
    pg_school_name: "",
    pg_school_place: "",
    pg_branch_name: "",
    pg_course_name: "",
    pg_year_of_passing: "",

    school_name: "",
    standard: "",
    school_place: "",
    year_of_passing: "",

    ///--iti
    iti_school_name: "",
    iti_school_place: "",
    iti_year_of_passing: "",
    iti_course_name: "",
    iti_branch_name: "",

    // sslc_id: "",
    // hsc_id: "",
    // diploma_id: "",
    // ug_id: "",
    // pg_id: "",
  };
  const [data, setData] = useState(initialState);
  const [sslcSchoolName, setSslcSchoolName] = useState("");
  const [sslcSchoolPlace, setSslcSchoolPlace] = useState("");
  const [sslcYearOfPassing, setSslcYearOfPassing] = useState("");
  const [sslcErr, setSslcErr] = useState({});

  console.log(images, "images", images[5]);
  const [diplomaErr, setDiplomaErr] = useState({});

  const [itiBranchName, setItiBranchName] = useState("");
  const [itiCourseName, setItiCourseName] = useState("");
  const [itiSchoolName, setItiSchoolName] = useState("");
  const [itiSchoolPlace, setItiSchoolPlace] = useState("");
  const [itiYearOfPassing, setItiYearOfPassing] = useState("");
  const [itiErr, setItiErr] = useState({});

  const [schoolName, setSchoolName] = useState("");
  const [schoolPlace, setSchoolPlace] = useState("");
  const [yearOfPassing, setYearOfPassing] = useState("");
  const [standardEr, setStanderr] = useState("");

  const [otherErr, setOtherErr] = useState({});
  const fileInputRef = useRef();

  const [hscErr, setHscErr] = useState({
    hsc_school_name: "",
    hsc_school_place: "",
    hsc_year_of_passing: "",
    // Add other error states as needed
  });

  const [ugErr, setUgErr] = useState({
    ug_branch_name: "",
    ug_course_name: "",
    ug_school_name: "",
    ug_school_place: "",
    // Add other error states as needed
  });

  const [pgErr, setPgErr] = useState({
    pg_branch_name: "",
    pg_course_name: "",
    pg_school_name: "",
    pg_school_place: "",
    // Add other error states as needed
  });

  const HandleChanges = (e) => {
    setFormDirty(true);
    setData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value.toUpperCase(),
      };
    });
  };

  useEffect(() => {
    if (
      state.FormsIDList.EducationID != "" &&
      state.FormsIDList.ActiveTabs == 5
    ) {
      let payload = {
        Retieveid: state.FormsIDList.EducationID,
      };

      dispatch(setEducationDataActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  useEffect(() => {
    // console.log(state.EducationAction.EducationData.not_studied, "EDUCarions", state.FormsIDList.EducationID , state.EducationAction.EducationData);
    if (
      state.FormsIDList.EducationID != " " &&
      state.EducationAction.EducationData.id != undefined &&
      state.FormsIDList.EducationID == state.EducationAction.EducationData.id
    ) {
      if (state.EducationAction.EducationData.sslc_school_name !== null) {
        setData({
          ...data,
          sslc_school_name:
            state.EducationAction.EducationData.sslc_school_name,
          sslc_school_place:
            state.EducationAction.EducationData.sslc_school_place,
          sslc_year_of_passing:
            state.EducationAction.EducationData.sslc_year_of_passing,
          hsc_year_of_passing:
            state.EducationAction.EducationData.hsc_year_of_passing,
          standard: state.EducationAction.EducationData.standard,
          hsc_school_place:
            state.EducationAction.EducationData.hsc_school_place,
          hsc_school_name: state.EducationAction.EducationData.hsc_school_name,
          ug_school_name: state.EducationAction.EducationData.ug_school_name,
          ug_school_place: state.EducationAction.EducationData.ug_school_place,
          ug_year_of_passing:
            state.EducationAction.EducationData.ug_year_of_passing,
          ug_course_name: state.EducationAction.EducationData.ug_course_name,
          ug_branch_name: state.EducationAction.EducationData.ug_branch_name,
          diploma_course_name:
            state.EducationAction.EducationData.diploma_course_name,
          diploma_school_name:
            state.EducationAction.EducationData.diploma_school_name,
          diploma_school_place:
            state.EducationAction.EducationData.diploma_school_place,
          diploma_year_of_passing:
            state.EducationAction.EducationData.diploma_year_of_passing,
          diploma_branch_name:
            state.EducationAction.EducationData.diploma_branch_name,
          pg_year_of_passing:
            state.EducationAction.EducationData.pg_year_of_passing,
          pg_course_name: state.EducationAction.EducationData.pg_course_name,
          pg_branch_name: state.EducationAction.EducationData.pg_branch_name,
          pg_school_place: state.EducationAction.EducationData.pg_school_place,
          pg_school_name: state.EducationAction.EducationData.pg_school_name,
          school_name: state.EducationAction.EducationData.school_name,
          school_place: state.EducationAction.EducationData.school_place,
          year_of_passing: state.EducationAction.EducationData.year_of_passing,
          iti_branch_name: state.EducationAction.EducationData.iti_branch_name,
          iti_course_name: state.EducationAction.EducationData.iti_course_name,
          iti_school_name: state.EducationAction.EducationData.iti_school_name,
          iti_school_place:
            state.EducationAction.EducationData.iti_school_place,
          iti_year_of_passing:
            state.EducationAction.EducationData.iti_year_of_passing,
          hsc_id: "",
          diploma_id: "",
          ug_id: "",
          pg_id: "",
        });
        setYearOfPassing(
          state.EducationAction.EducationData.sslc_year_of_passing,
        );
      }

      // codeInit();
    }

    // if (state.FormsIDList.EducationID === "") {
    //   setUpdateStatus(true);
    // }
    if (
      state.FormsIDList.EducationID !== "" &&
      state.EducationAction.EducationData.not_studied != null &&
      state.EducationAction.EducationData.not_studied != undefined

      // state.EducationAction.EducationData.not_studied === true
    ) {
      setUpdateStatus(state.EducationAction.EducationData.not_studied);
    }
  }, [
    state.FormsIDList.ActiveTabs,
    state.EducationAction.EducationData,
    state.FormsIDList.EducationID,
    state.EducationAction.EducationData.not_studied,
  ]);
  useEffect(() => {
    if (
      state.FormsIDList.EducationID != " " &&
      state.EducationAction.EducationData.id != undefined &&
      state.FormsIDList.EducationID == state.EducationAction.EducationData.id
    ) {
      codeInit();
    }
  }, [state.FormsIDList.ActiveTabs, state.EducationAction.EducationData, data]);
  const inputRef = useRef();
  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, "");

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  useEffect(() => {
    let newImages = [...images];

    if (
      state.FormsIDList.EducationID != " " &&
      state.EducationAction.EducationData.id != undefined &&
      state.FormsIDList.EducationID == state.EducationAction.EducationData.id
    ) {
      if (
        state.EducationAction.EducationData.sslc_id != undefined &&
        state.EducationAction.EducationData.sslc_id != null &&
        state.EducationAction.EducationData.sslc_id &&
        state.EducationAction.EducationData.sslc_id.media_url
      ) {
        newImages[0] = state.EducationAction.EducationData.sslc_id.media_url; // 10th image as 1st index
      }
      if (
        state.EducationAction.EducationData.hsc_id != null &&
        state.EducationAction.EducationData.hsc_id != undefined &&
        state.EducationAction.EducationData.hsc_id &&
        state.EducationAction.EducationData.hsc_id.media_url
      ) {
        newImages[1] = state.EducationAction.EducationData.hsc_id.media_url; // 12th image as 2nd index
      }
      if (
        state.EducationAction.EducationData.diploma_id != undefined &&
        state.EducationAction.EducationData.diploma_id != null &&
        state.EducationAction.EducationData.diploma_id &&
        state.EducationAction.EducationData.diploma_id.media_url
      ) {
        newImages[2] = state.EducationAction.EducationData.diploma_id.media_url; // Diploma image as 3rd index
      }
      if (
        state.EducationAction.EducationData.ug_id != null &&
        state.EducationAction.EducationData.ug_id != undefined &&
        state.EducationAction.EducationData.ug_id &&
        state.EducationAction.EducationData.ug_id.media_url
      ) {
        newImages[3] = state.EducationAction.EducationData.ug_id.media_url; // UG image as 4th index
      }
      if (
        state.EducationAction.EducationData.pg_id != null &&
        state.EducationAction.EducationData.pg_id != undefined &&
        state.EducationAction.EducationData.pg_id &&
        state.EducationAction.EducationData.pg_id.media_url
      ) {
        newImages[4] = state.EducationAction.EducationData.pg_id.media_url; // PG image as 5th index
      }
      if (
        state.EducationAction.EducationData.iti_id != null &&
        state.EducationAction.EducationData.iti_id != undefined &&
        state.EducationAction.EducationData.iti_id &&
        state.EducationAction.EducationData.iti_id.media_url
      ) {
        newImages[5] = state.EducationAction.EducationData.iti_id.media_url; // ITI image as 6th index (optional)
      }
    }

    setImages(newImages);
    setPresentImages(newImages);
  }, [state.FormsIDList.EducationID, state.EducationAction.EducationData]);
  console.log(images, "29387images", state.EducationAction.EducationData);

  const [selectedEducation, setSelectedEducation] = useState([]);
  const [educationOptions, setEducationOptions] = useState([
    { value: "10th", label: "10th" },
    { value: "12th", label: "12th" },

    { value: "ITI", label: "ITI" },

    { value: "Diploma", label: "Diploma" },
    { value: "UG", label: "UG" },
    { value: "PG", label: "PG" },
    { value: "OTHER", label: "OTHER" },
  ]);
  const resetValuesByPrefix = (prefix, state) => {
    const updatedState = { ...state };
    for (const key in updatedState) {
      console.log(key, "0826wsoix", prefix, key.includes(prefix));
      if (key.includes(prefix)) {
        updatedState[key] = "";
      }
    }
    return updatedState;
  };
  // const handleEducationChange = (selectedValue) => {
  //   console.log(selectedValue, "selectedValue");
  //   // if (
  //   //   selectedValue == "PG" &&
  //   //   selectedValue.includes("10th") &&
  //   //   selectedValue.includes("12th") &&
  //   //   selectedValue.includes("UG")
  //   // ) {
  //   //   setEducationOptions((prevOptions) =>
  //   //     prevOptions.filter((option) => option.value !== selectedValue)
  //   //   );
  //   //   setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //   // } else if (
  //   //   (selectedValue == "PG") ||
  //   //   !selectedValue.includes("10th") ||
  //   //   !selectedValue.includes("12th") ||
  //   //   !selectedValue.includes("UG")
  //   // ) {
  //   //   toast.error("Please select 10th and 12th standard. And UG", {
  //   //     position: toast.POSITION.TOP_RIGHT,
  //   //   });

  //   // }

  //   // else {
  //     setEducationOptions((prevOptions) =>
  //       prevOptions.filter((option) => option.value !== selectedValue)
  //     );

  //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //   // }
  // };

  // const handleEducationChange = (selectedValue) => {
  //   console.log(selectedValue, "selectedValue");

  //   if (selectedValue === "PG") {
  //     if (
  //       selectedEducation.includes("10th") &&
  //       selectedEducation.includes("12th") &&
  //       selectedEducation.includes("UG")
  //     ) {
  //       setEducationOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== selectedValue)
  //       );
  //       setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //     } else {
  //       toast.error("Please select 10th, 12th, and UG before selecting PG.", {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //     }
  //   } else if (selectedValue === "UG") {
  //     if (
  //       selectedEducation.includes("10th") &&
  //       selectedEducation.includes("12th")
  //     ) {
  //       setEducationOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== selectedValue)
  //       );
  //       setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //     } else {
  //       toast.error("Please select 10th and 12th before selecting UG.", {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //     }
  //   } else {
  //     setEducationOptions((prevOptions) =>
  //       prevOptions.filter((option) => option.value !== selectedValue)
  //     );
  //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //   }
  // };

  const handleEducationChange = (selectedValue, Popup) => {
    console.log(selectedValue, "selectedValue", Popup);

    // if (selectedValue === "PG") {
    //   if (
    //     selectedEducation.includes("10th") &&
    //     selectedEducation.includes("12th") &&
    //     selectedEducation.includes("UG")
    //   ) {
    //     setEducationOptions((prevOptions) =>
    //       prevOptions.filter((option) => option.value !== selectedValue),
    //     );
    //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
    //   } else {
    //     if (Popup != "Nopopup") {
    //       toast.error("Please select 10th, 12th, and UG before selecting PG.", {
    //         position: toast.POSITION.TOP_RIGHT,
    //       });
    //     }
    //   }
    // } else if (selectedValue === "UG") {
    //   if (
    //     selectedEducation.includes("10th") &&
    //     selectedEducation.includes("12th")
    //     // selectedEducation.includes("Diploma")
    //   ) {
    //     setEducationOptions((prevOptions) =>
    //       prevOptions.filter((option) => option.value !== selectedValue),
    //     );
    //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
    //   } else {
    //     if (Popup != "Nopopup") {
    //       toast.error("Please select 10th, 12th, before selecting UG.", {
    //         position: toast.POSITION.TOP_RIGHT,
    //       });
    //     }
    //   }
    // } else if (selectedValue === "Diploma") {
    //   if (selectedEducation.includes("10th")) {
    //     setEducationOptions((prevOptions) =>
    //       prevOptions.filter((option) => option.value !== selectedValue),
    //     );
    //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
    //   } else {
    //     if (Popup != "Nopopup") {
    //       toast.error("Please select 10th before selecting Diploma.", {
    //         position: toast.POSITION.TOP_RIGHT,
    //       });
    //     }
    //   }
    // } else {
    setEducationOptions((prevOptions) =>
      prevOptions.filter((option) => option.value !== selectedValue),
    );
    setSelectedEducation((prevState) => [...prevState, selectedValue]);
  };
  // };
  // const handleEducationChange = (selectedValue, Popup) => {
  //   console.log(selectedValue, "selectedValue", Popup);

  //   if (selectedValue === "PG") {
  //     if (
  //       selectedEducation.includes("10th") &&
  //       selectedEducation.includes("12th") &&
  //       selectedEducation.includes("UG")
  //     ) {
  //       setEducationOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== selectedValue),
  //       );
  //       setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //     } else {
  //       if (Popup != "Nopopup") {
  //         toast.error("Please select 10th, 12th, and UG before selecting PG.", {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //       }
  //     }
  //   } else if (selectedValue === "UG") {
  //     if (
  //       selectedEducation.includes("10th") &&
  //       selectedEducation.includes("12th")
  //       // selectedEducation.includes("Diploma")
  //     ) {
  //       setEducationOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== selectedValue),
  //       );
  //       setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //     } else {
  //       if (Popup != "Nopopup") {
  //         toast.error("Please select 10th, 12th, before selecting UG.", {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //       }
  //     }
  //   } else if (selectedValue === "Diploma") {
  //     if (selectedEducation.includes("10th")) {
  //       setEducationOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== selectedValue),
  //       );
  //       setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //     } else {
  //       if (Popup != "Nopopup") {
  //         toast.error("Please select 10th before selecting Diploma.", {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //       }
  //     }
  //   } else {
  //     setEducationOptions((prevOptions) =>
  //       prevOptions.filter((option) => option.value !== selectedValue),
  //     );
  //     setSelectedEducation((prevState) => [...prevState, selectedValue]);
  //   }
  // };

  const handleRemoveEducation = (removedValue, prefix) => {
    setFormDirty(true);
    console.log(removedValue, "0187230removedValue", prefix);
    setSelectedEducation((prevSelected) =>
      prevSelected.filter((value) => value !== removedValue),
    );
    setEducationOptions((prevOptions) => [
      ...prevOptions,
      { label: removedValue, value: removedValue },
    ]);
    setData(resetValuesByPrefix(prefix, data));
  };

  const codeInit = () => {
    if (
      data.sslc_school_name !== "" ||
      data.sslc_school_place !== "" ||
      data.sslc_year_of_passing !== ""
    ) {
      handleEducationChange("10th", "Nopopup");
    }
    if (
      data.pg_branch_name?.length !== 0 ||
      data.pg_course_name?.length !== 0 ||
      data.pg_school_name?.length !== 0 ||
      data.pg_school_place?.length !== 0
    ) {
      handleEducationChange("PG", "Nopopup");
    }
    if (
      data.ug_branch_name?.length !== 0 ||
      data.ug_course_name?.length !== 0 ||
      data.ug_school_name?.length !== 0 ||
      data.ug_school_place?.length !== 0
    ) {
      handleEducationChange("UG", "Nopopup");
    }
    if (
      data.diploma_branch_name?.length !== 0 ||
      data.diploma_course_name?.length !== 0 ||
      data.diploma_school_name?.length !== 0 ||
      data.diploma_school_place?.length !== 0
    ) {
      handleEducationChange("Diploma", "Nopopup");
    }
    if (
      data.hsc_school_name?.length !== 0 ||
      data.hsc_school_place?.length !== 0 ||
      data.hsc_year_of_passing?.length !== 0
    ) {
      handleEducationChange("12th", "Nopopup");
    }

    if (
      data.iti_branch_name?.length !== 0 ||
      data.iti_course_name?.length !== 0 ||
      data.iti_school_name?.length !== 0 ||
      data.iti_school_place?.length !== 0 ||
      data.iti_year_of_passing?.length !== 0
    ) {
      handleEducationChange("ITI", "Nopopup");
    }

    if (
      data.school_name?.length !== 0 ||
      data.school_place?.length !== 0 ||
      data.standard?.length !== 0 ||
      data.year_of_passing?.length !== 0
    ) {
      handleEducationChange("OTHER", "Nopopup");
    }
  };

  const ugTemplate = [
    [
      {
        label: "Institute Name",
        value: data.ug_school_name,
        name: "ug_school_name",
      },
      {
        label: "Institute Place",
        value: data.ug_school_place,
        name: "ug_school_place",
      },
    ],
    [
      { label: "Course", value: data.ug_course_name, name: "ug_course_name" },
      { label: "Branch", value: data.ug_branch_name, name: "ug_branch_name" },
      {
        label: "Year Of Passout",
        value: data.ug_year_of_passing,
        name: "ug_year_of_passing",
      },
    ],
  ];
  const postGraduationTemplate = [
    [
      {
        label: "Institute Name",
        value: data.pg_school_name,
        name: "pg_school_name",
      },
      {
        label: "Institute Place",
        value: data.pg_school_place,
        name: "pg_school_place",
      },
    ],
    [
      { label: "Course", value: data.pg_course_name, name: "pg_course_name" },
      { label: "Branch", value: data.pg_branch_name, name: "pg_branch_name" },
      {
        label: "Year Of Passout",
        value: data.pg_year_of_passing,
        name: "pg_year_of_passing",
      },
    ],
  ];
  const diplomaTemplate = [
    [
      {
        label: "Diploma Institute Name",
        value: data.diploma_school_name,
        name: "diploma_school_name",
      },
      {
        label: "Institute Place",
        value: data.diploma_school_place,
        name: "diploma_school_place",
      },
    ],
    [
      {
        label: "Course",
        value: data.diploma_course_name,
        name: "diploma_course_name",
      },
      {
        label: "Branch",
        value: data.diploma_branch_name,
        name: "diploma_branch_name",
      },
      {
        label: "Year Of Passout",
        value: data.diploma_year_of_passing,
        name: "diploma_year_of_passing",
      },
    ],
  ];

  const OtherBasicInfo = [
    [
      {
        label: "School Name",
        value: data.school_name,
        name: "school_name",
      },
      {
        label: "School Place",
        value: data.school_place,
        name: "school_place",
      },
    ],
    [
      {
        label: "Qualification",
        value: data.standard,
        name: "standard",
      },

      {
        label: "Year of passout",
        value: data.year_of_passing,
        name: "year_of_passing",
      },
    ],
  ];

  const sslcTemplate = [
    [
      {
        label: "10th School Name",
        value: data.sslc_school_name,
        name: "sslc_school_name",
      },
      {
        label: "10th School Place",
        value: data.sslc_school_place,
        name: "sslc_school_place",
      },
    ],
    [
      {
        label: "10th Year Of Passing",
        value: data.sslc_year_of_passing,
        name: "sslc_year_of_passing",
      },
    ],
  ];

  //  console.log(data , "datajeyfoqywdoi");
  const ITIGraduationTemplate = [
    [
      {
        label: "ITI Institute Name",
        value: data.iti_school_name,
        name: "iti_school_name",
      },
      {
        label: "ITI Institute Place",
        value: data.iti_school_place,
        name: "iti_school_place",
      },
    ],
    [
      { label: "Course", value: data.iti_course_name, name: "iti_course_name" },
      { label: "Branch", value: data.iti_branch_name, name: "iti_branch_name" },
    ],
    [
      {
        label: "ITI Year Of Passing",
        value: data.iti_year_of_passing,
        name: "iti_year_of_passing",
      },
    ],
  ];

  const [imageFileChange, setImageFileChange] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [updateImage, setUpdateImage] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [url, setUrl] = useState();
  console.log(url);
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [updatedst, setupdatest] = useState();

  const [crop, setCrop] = useState();
  //   {
  //   unit: '%', // Can be 'px' or '%'
  //   x: 0,
  //   y: 0,
  //   width: 100,
  //   height: 100,
  // }

  const fixedCropSize = { width: 300, height: 200 };
  const cancel = (e) => {
    setalert(true);

    setUrl("");
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };
  const [forindex, setforindex] = useState();

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], "croppedimg.jpg", {
          type: "image/jpeg",
        });
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false);
          }, 0);
        }

        setImageFileChange((prevState) => {
          const newState = [...prevState];
          newState[forindex] = true;
          return newState;
        });

        const updatedImagesFile = [...imagesFile];

        updatedImagesFile[forindex] = croppedFile;
        setImagesFile(updatedImagesFile);
        const generateRandomNumber = () => {
          return Math.floor(Math.random() * 100000);
        };
        console.log(forindex, "ouauyeiuqywforindex");

        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/${forindex == 0 ? "sslc" : forindex == 1 ? "hsc" : forindex == 2 ? "diploma" : forindex == 3 ? "ug" : forindex == 4 ? "pg" : forindex == 5 && "iti"}/${forindex == 0 ? "sslc" : forindex == 1 ? "hsc" : forindex == 2 ? "diploma" : forindex == 3 ? "ug" : forindex == 4 ? "pg" : forindex == 5 && "iti"}${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        const Presentdata = createPresentData(croppedFile);

        axios({
          url: PresentUrl,
          method: "post",
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
          .then((response) => {
            // console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data; // Adjust based on actual response structure
            // console.log(uploadedFiles ,"uploadedFiles");

            const newUrls = uploadedFiles.map((file) => ({
              url: file, // Adjust this based on the actual response
              type: croppedFile.type,
              putfiles: croppedFile,
            }));

            // Update PresentUrls state
            // setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
            setPresentUrls((prevUrls) => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = newUrls[0];
              return updatedUrls;
            });

            const Urls = uploadedFiles.map((file) => ({
              url: file,
            }));

            const updatedImagespreFile = [...Presentimages];

            updatedImagespreFile[forindex] = String(response.data.data).split(
              "?",
            )[0];
            setPresentImages(updatedImagespreFile);
          })
          .catch((error) => {
            console.error("Error uploading files:", error);
          });

        var file = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });

          if (updatedst) {
            setUpdateImage((prevState) => {
              const newState = [...prevState];
              newState[forindex] = true;
              return newState;
            });
          }
        };
        reader.readAsDataURL(file);
        blob.name = fileName;
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }
  // const handleDocumentUpload = (file, index) => {
  //   setCroppImageView(false);
  //   console.log(file, "filehandleDocumentUpload");
  //   setImageFileChange((prevState) => {
  //     const newState = [...prevState];
  //     newState[index] = true;
  //     return newState;
  //   });

  //   const updatedImagesFile = [...imagesFile];
  //   updatedImagesFile[index] = file;
  //   setImagesFile(updatedImagesFile);

  //   const generateRandomNumber = () => Math.floor(Math.random() * 100000);

  //   const folderMap = ["sslc", "hsc", "diploma", "ug", "pg", "iti"];
  //   const folder = folderMap[index] || "others";

  //   const randomNumber = generateRandomNumber();
  //   const extension = file.name.split(".").pop();

  //   const formattedFilename = `onboarding/${folder}/${folder}${randomNumber}.${extension}`;

  //   const Presentdata = {
  //     multiple_files: [
  //       {
  //         filename: formattedFilename,
  //         file_type: file.type,
  //       },
  //     ],
  //   };

  //   axios({
  //     url: PresentUrl,
  //     method: "post",
  //     data: Presentdata,
  //     headers: {
  //       Authorization:
  //         "Bearer " + store.getState().users.UserData.session.token,
  //     },
  //   })
  //     .then((response) => {
  //       const uploadedFiles = response.data.data;

  //       const newUrls = uploadedFiles.map((fileUrl) => ({
  //         url: fileUrl,
  //         type: file.type,
  //         putfiles: file,
  //       }));

  //       setPresentUrls((prevUrls) => {
  //         const updated = [...prevUrls];
  //         updated[index] = newUrls[0];
  //         return updated;
  //       });

  //       const updatedImagespreFile = [...Presentimages];
  //       updatedImagespreFile[index] = String(response.data.data).split("?")[0];
  //       setPresentImages(updatedImagespreFile);
  //     })
  //     .catch((error) => {
  //       console.error("Error uploading files:", error);
  //     });
  // };

  const handleDocumentUpload = (file, index) => {
    setCroppImageView(false);

    setImageFileChange((prevState) => {
      const newState = [...prevState];
      newState[index] = true;
      return newState;
    });

    setImagesFile((prev) => {
      const updated = [...prev];
      updated[index] = file;
      return updated;
    });

    // ✅ ADD THIS BLOCK (setImages)
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImages((prev) => {
          const updated = [...prev];
          updated[index] = reader.result; // image preview
          return updated;
        });
      };
      reader.readAsDataURL(file);
    } else {
      // for PDF / Excel → show file name or icon
      setImages((prev) => {
        const updated = [...prev];
        updated[index] = file.name; // or use icon path
        return updated;
      });
    }

    const folderMap = ["sslc", "hsc", "diploma", "ug", "pg", "iti"];
    const folder = folderMap[index] || "others";

    const randomNumber = Math.floor(Math.random() * 100000);
    const extension = file.name?.split(".").pop() || file.type.split("/")[1];

    const formattedFilename = `onboarding/${folder}/${folder}${randomNumber}.${extension}`;

    const payload = {
      multiple_files: [
        {
          filename: formattedFilename,
          file_type: file.type,
        },
      ],
    };

    axios({
      url: PresentUrl,
      method: "post",
      data: payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    })
      .then((response) => {
        const uploadedFiles = response.data.data;
        const fileUrl = uploadedFiles?.[0];

        setPresentUrls((prev) => {
          const updated = [...prev];
          updated[index] = {
            url: fileUrl,
            type: file.type,
            putfiles: file,
          };
          return updated;
        });

        setPresentImages((prev) => {
          const updated = [...prev];
          updated[index] = String(fileUrl).split("?")[0];
          return updated;
        });
      })
      .catch((error) => {
        console.error("Error uploading files:", error);
      });
  };
  console.log(PresentUrls, "dasdakldkakld", Presentimages);

  const updateAvatar = (imgSrc) => {
    fileInputRef.current.value = imgSrc;
  };

  // const handleFileChange = (event, index, update = false) => {
  //   const file = event.target.files[0];

  //   const allowedTypes = [
  //     "image/jpeg",
  //     "image/png",
  //     "image/svg+xml",
  //     "application/pdf",
  //     "application/vnd.ms-excel",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   ];

  //   const maxSize = 10 * 1024 * 1024; // 10MB
  //   const MIN_DIMENSION = 150;

  //   setalert(true);
  //   setupdatest(update);
  //   setFormDirty(true);
  //   setCroppImageViewCount(index);
  //   setEducationFiles(event);

  //   if (!file || !allowedTypes.includes(file.type)) {
  //     setCroppImageView(false);
  //     toast.error("Invalid file type. Allowed: image, PDF, Excel");
  //     return;
  //   }

  //   if (file.size > maxSize) {
  //     setCroppImageView(false);
  //     toast.error("File size exceeds 10MB.");
  //     return;
  //   }

  //   // ✅ Check if it's an image
  //   const isImage = file.type.startsWith("image/");

  //   if (!isImage) {
  //     // 👉 PDF / Excel → skip crop & dimension check
  //     setCroppImageView(false);
  //     handleDocumentUpload(file, index);
  //     selectedImage(event, index);
  //     return;
  //   }

  //   // ✅ Only images go here
  //   setCroppImageView(true);

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     const imageElement = new Image();
  //     imageElement.src = reader.result;

  //     imageElement.onload = (imgEvent) => {
  //       const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

  //       if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
  //         toast.error("Image must be at least 150 x 150 pixels.");
  //         setCroppImageView(false);
  //         return;
  //       }

  //       selectedImage(event, index);
  //     };
  //   };

  //   reader.readAsDataURL(file);
  // };
  const handleFileChange = (event, index, update = false) => {
    // console.log(event, index, update, "sadasdasbdasbdhabsd");

    const file = event.target.files[0];
    console.log(file, "file");
    // const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "application/pdf", // PDF
      "application/vnd.ms-excel", // Excel (.xls)
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Excel (.xlsx)
    ];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    console.log(file, "djksdkjajkdjkajda");
    const isImage = file.type.startsWith("image/");

    if (!isImage) {
      console.log(file, "dkaskldkalskldakd");
      handleDocumentUpload(file, index);
      selectedImage(event, index);
      return;
    }
    setCroppImageView(true);
    setalert(true);
    setupdatest(update);
    setFormDirty(true);
    setCroppImageViewCount(index);

    setEducationFiles(event);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;
          console.log(file, "dkaskdkladlkal", imageUrl);

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(event, index);
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }

    // setforindex(index)

    //   setImageFileChange((prevState) => {
    //     const newState = [...prevState];
    //     newState[forindex] = true;
    //     return newState;
    //   });

    //  const updatedImagesFile = [...imagesFile];

    //   updatedImagesFile[forindex] = event.target.files[0];
    //   setImagesFile(updatedImagesFile);

    //   console.log(imagesFile, "imagesFile" , forindex);

    // const file = event.target.files[0];

    // if (file) {
    //   // const reader = new FileReader();
    //   // reader.onload = (e) => {
    //   //   setImages((prevImages) => {
    //   //     const newImages = [...prevImages];
    //   //     newImages[index] = e.target.result;
    //   //     return newImages;
    //   //   });
    //   // };
    //   // reader.readAsDataURL(file);
    // }
    // if (update) {
    //   // setUpdateImage((prevState) => {
    //   //   const newState = [...prevState];
    //   //   newState[index] = true;
    //   //   return newState;
    //   // });
    // }

    //   console.log(images ,updateImage , "updateImage" );
  };

  console.log(
    state.NumberCounts.Editable,
    "NumberCounts",
    state.ClientBranchIDs.SUBROLE,
  );

  const [initState, setInitState] = useState(false);
  const [uneducated, setUneducated] = useState(false);
  //  console.log(data.sslc_year_of_passing , "83ys/8de", sslcErr);

  const validateHsc = () => {
    let errors = {};
    let isValid = true;

    if (!isAthena && data.hsc_school_name.trim() === "") {
      errors.hsc_school_name = "* School Name is required";
      isValid = false;
    }
    if (data.hsc_school_place.trim() === "") {
      errors.hsc_school_place = "* School Place is required";
      isValid = false;
    }
    if (data.hsc_year_of_passing.trim() === "") {
      errors.hsc_year_of_passing = "* Year of Passing is required";
      isValid = false;
    } else if (!/^\d{4}$/.test(data.hsc_year_of_passing.trim())) {
      errors.hsc_year_of_passing = "* Enter a valid year (4 digits)";
      isValid = false;
    }

    setHscErr(errors);
    return isValid;
  };

  // Validation function for Diploma education section
  const validateDiploma = () => {
    let errors = {};
    let isValid = true;

    if (data.diploma_branch_name.trim() === "") {
      errors.diploma_branch_name = "*Branch Name is required";
      isValid = false;
    }
    if (data.diploma_course_name.trim() === "") {
      errors.diploma_course_name = "*Course Name is required";
      isValid = false;
    }
    if (!isAthena && data.diploma_school_name.trim() === "") {
      errors.diploma_school_name = "*Diploma Institute Name is required";
      isValid = false;
    }
    if (data.diploma_school_place.trim() === "") {
      errors.diploma_school_place = "*Institute Place is required";
      isValid = false;
    }
    if (data.diploma_year_of_passing.trim() === "") {
      errors.diploma_year_of_passing = "*Year of Passing is required";
      isValid = false;
    }

    setDiplomaErr(errors);
    return isValid;
  };

  const validateInputs = () => {
    let isValid = true;
    const errors = {};

    // Validation logic
    if (!data.ug_branch_name.trim()) {
      errors.ug_branch_name = "*Branch name is required";
      isValid = false;
    }

    if (!data.ug_course_name.trim()) {
      errors.ug_course_name = "*Course name is required";
      isValid = false;
    }

    if (!isAthena && !data.ug_school_name.trim()) {
      errors.ug_school_name = "*Institute Name is required";
      isValid = false;
    }

    if (!data.ug_school_place.trim()) {
      errors.ug_school_place = "*Institute Place is required";
      isValid = false;
    }

    if (data.ug_year_of_passing.trim() === "") {
      errors.ug_year_of_passing = "*Year of Passing is required";
      isValid = false;
    }
    setUgErr(errors);

    return isValid;
  };

  const validatePg = () => {
    let isValid = true;
    const errors = {};

    // Validation logic
    if (!data.pg_branch_name.trim()) {
      errors.pg_branch_name = "*Branch name is required";
      isValid = false;
    }

    if (!data.pg_course_name.trim()) {
      errors.pg_course_name = "*Course name is required";
      isValid = false;
    }

    if (!isAthena && !data.pg_school_name.trim()) {
      errors.pg_school_name = "*Institute Name is required";
      isValid = false;
    }

    if (!data.pg_school_place.trim()) {
      errors.pg_school_place = "*Institute Place is required";
      isValid = false;
    }
    if (data.pg_year_of_passing.trim() === "") {
      errors.pg_year_of_passing = "*Year of Passing is required";
      isValid = false;
    }
    setPgErr(errors);

    return isValid;
  };

  const [SelectionErr, setSelectionErr] = useState("");

  const educationData = state.EducationAction.EducationData;

  const educationUrls = [
    educationData.sslc_id?.media_url,
    educationData.hsc_id?.media_url,
    educationData.diploma_id?.media_url,
    educationData.ug_id?.media_url,
    educationData.pg_id?.media_url,
    educationData.iti_id?.media_url,
  ].filter(Boolean);

  const normalizeUrl = (url) => url?.trim().toLowerCase();

  const educationUrlsNormalized = educationUrls.map(normalizeUrl);

  const imagesNormalized = images
    .map((img) => (img ? normalizeUrl(img) : null))
    .filter(Boolean);
  var hasMismatch = imagesNormalized.some((imgUrl, index) => {
    console.log(
      educationUrlsNormalized[index],
      "educationUrlsNormalized",
      imgUrl,
    );

    // Use return to make it a valid expression in .some
    return imgUrl !== educationUrlsNormalized[index];
  });

  const HandleNext = () => {
    var a = 0;
    let B = 0;
    let iti = 0;
    let errors = {};
    let itiErrors = {};

    let bacis = 0;
    let other = 0;
    let otherErrors = {};
    let ug = 0;
    let pg = 0;

    formData.append(
      "data",
      JSON.stringify({
        sslc_school_name: data.sslc_school_name.trim(),
        sslc_school_place: data.sslc_school_place.trim(),
        sslc_year_of_passing: data.sslc_year_of_passing,
        hsc_school_name: data.hsc_school_name.trim(),
        hsc_school_place: data.hsc_school_place.trim(),
        hsc_year_of_passing: data.hsc_year_of_passing,
        ug_school_name: data.ug_school_name.trim(),
        ug_school_place: data.ug_school_place.trim(),
        ug_year_of_passing: data.ug_year_of_passing,
        ug_course_name: data.ug_course_name.trim(),
        ug_branch_name: data.ug_branch_name.trim(),
        diploma_school_name: data.diploma_school_name.trim(),
        diploma_school_place: data.diploma_school_place.trim(),
        diploma_year_of_passing: data.diploma_year_of_passing,
        diploma_branch_name: data.diploma_branch_name.trim(),
        diploma_course_name: data.diploma_course_name.trim(),
        pg_school_name: data.pg_school_name.trim(),
        pg_school_place: data.pg_school_place.trim(),
        pg_branch_name: data.pg_branch_name.trim(),
        pg_course_name: data.pg_course_name.trim(),
        pg_year_of_passing: data.pg_year_of_passing,
        // not_studied: false,
        not_studied: updateStatus,
        school_name: data.school_name.trim(),
        standard: data.standard.trim(),
        school_place: data.school_place.trim(),
        year_of_passing: data.year_of_passing,
        ///--iti
        iti_school_name: data.iti_school_name.trim(),
        iti_school_place: data.iti_school_place.trim(),
        iti_year_of_passing: data.iti_year_of_passing.trim(),
        iti_course_name: data.iti_course_name.trim(),
        iti_branch_name: data.iti_branch_name.trim(),
        timeline_id:
          state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
      }),
    );

    if (imageFileChange[0] === true) {
      formData.append("sslc_id", imagesFile[0]);
    }
    if (imageFileChange[1] === true) {
      formData.append("hsc_id", imagesFile[1]);
    }
    if (imageFileChange[2] === true) {
      formData.append("diploma_id", imagesFile[2]);
    }
    if (imageFileChange[3] === true) {
      formData.append("ug_id", imagesFile[3]);
    }
    if (imageFileChange[4] === true) {
      formData.append("pg_id", imagesFile[4]);
    }
    if (imageFileChange[5] === true) {
      formData.append("iti_id", imagesFile[5]);
    }

    let EducationCRUD_DATA = {
      sslc_school_name: data.sslc_school_name.trim(),
      sslc_school_place: data.sslc_school_place.trim(),
      sslc_year_of_passing: data.sslc_year_of_passing,
      hsc_school_name: data.hsc_school_name.trim(),
      hsc_school_place: data.hsc_school_place.trim(),
      hsc_year_of_passing: data.hsc_year_of_passing,
      ug_school_name: data.ug_school_name.trim(),
      ug_school_place: data.ug_school_place.trim(),
      ug_year_of_passing: data.ug_year_of_passing,
      ug_course_name: data.ug_course_name.trim(),
      ug_branch_name: data.ug_branch_name.trim(),
      diploma_school_name: data.diploma_school_name.trim(),
      diploma_school_place: data.diploma_school_place.trim(),
      diploma_year_of_passing: data.diploma_year_of_passing,
      diploma_branch_name: data.diploma_branch_name.trim(),
      diploma_course_name: data.diploma_course_name.trim(),
      pg_school_name: data.pg_school_name.trim(),
      pg_school_place: data.pg_school_place.trim(),
      pg_branch_name: data.pg_branch_name.trim(),
      pg_course_name: data.pg_course_name.trim(),
      pg_year_of_passing: data.pg_year_of_passing,
      // not_studied: false,
      not_studied: updateStatus,
      school_name: data.school_name.trim(),
      standard: data.standard.trim(),
      school_place: data.school_place.trim(),
      year_of_passing: data.year_of_passing,
      ///--iti
      iti_school_name: data.iti_school_name.trim(),
      iti_school_place: data.iti_school_place.trim(),
      iti_year_of_passing: data.iti_year_of_passing.trim(),
      iti_course_name: data.iti_course_name.trim(),
      iti_branch_name: data.iti_branch_name.trim(),
      timeline_id:
        state.BasicFormCreated.BasciFormCreate == ""
          ? state.EmployeeProfile.EmployeeProfileList.id
          : state.BasicFormCreated.BasciFormCreate,
      sslc_id: Presentimages[0],
      hsc_id: Presentimages[1],
      diploma_id: Presentimages[2],
      ug_id: Presentimages[3],
      pg_id: Presentimages[4],
      iti_id: Presentimages[5],
    };

    for (let [key, value] of formData.entries()) {
      console.log(key, value, "830740disndvalue");
    }

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });
              if (PresentUrls.length == index + 1) {
                setImageFileChange([false, false, false, false, false, false]);
              }
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };

    if (!updateStatus) {
      if (selectedEducation.length == 0) {
        // console.log(formDirty ,  "9823482374");

        setSelectionErr("*Please Select one of the education ");
        B = 1;
        a = 1;
        setFormDirty(true);
      }
      if (updateStatus) {
        B = 0;
        a = 0;
      }
      if (selectedEducation.includes("10th")) {
        // SSLC School Name validation
        if (!isAthena && data.sslc_school_name === "") {
          errors.sslc_school_name = "*School Name is required";
          a = 1;
          bacis = 1;
        }

        // SSLC School Place validation
        if (data.sslc_school_place === "") {
          errors.sslc_school_place = "*School Place is required";
          a = 1;
          bacis = 1;
        }

        // SSLC Year of Passing validation
        if (
          data?.sslc_year_of_passing === "" ||
          data?.sslc_year_of_passing === null ||
          data?.sslc_year_of_passing === undefined
        ) {
          errors.sslc_year_of_passing = "*Year of Passing is required";
          a = 1;
          bacis = 1;
        } else if (!/^\d{4}$/.test(data?.sslc_year_of_passing)) {
          errors.sslc_year_of_passing = "*Enter a valid year (4 digits)";
          a = 1;
          bacis = 1;
        }

        setSslcErr(errors);
      }

      if (selectedEducation.includes("ITI")) {
        if (data.iti_branch_name === "") {
          itiErrors.iti_branch_name = "*Branch name is required";
          a = 1;
          iti = 1;
        }
        if (data.iti_course_name === "") {
          itiErrors.iti_course_name = "*Course name is required";
          a = 1;
          iti = 1;
        }
        if (!isAthena && data.iti_school_name === "") {
          itiErrors.iti_school_name = "*Iti institute name is required";
          a = 1;
          iti = 1;
        }
        if (data.iti_school_place === "") {
          itiErrors.iti_school_place = "*Iti institute place is required";
          a = 1;
          iti = 1;
        }
        if (data.iti_year_of_passing === "") {
          itiErrors.iti_year_of_passing = "*Year of passing is required";
          a = 1;
          iti = 1;
        } else if (!/^\d{4}$/.test(data.iti_year_of_passing)) {
          itiErrors.iti_year_of_passing = "*Enter a valid year (4 digits)";
          a = 1;
          iti = 1;
        }

        setItiErr(itiErrors);
      }

      if (selectedEducation.includes("OTHER")) {
        // Validation logic
        console.log("Validation logic", selectedEducation);
        if (!isAthena && data.school_name === "") {
          otherErrors.school_name = "*School Name is required";
          a = 1;
          other = 1;
        }
        if (data.school_place === "") {
          otherErrors.school_place = "*School Place is required";
          a = 1;
          other = 1;
        }

        if (data.standard === "") {
          otherErrors.standard = "*Qualification is required";
          a = 1;
          other = 1;
        }

        if (data.year_of_passing === "") {
          otherErrors.year_of_passing = "*Year of Passing is required";
          a = 1;
          other = 1;

          // } else if (!/^\d{4}$/.test(yearOfPassing)) {
          //   otherErrors.year_of_passing = '*Enter a valid year (4 digits)';
          //   a = 1;
          //   other= 1;

          // }
        } else if (!/^\d{4}$/.test(data.year_of_passing)) {
          otherErrors.year_of_passing = "*Enter a valid year (4 digits)";
          a = 1;
          other = 1;
        }

        setOtherErr(otherErrors);
      }

      if (selectedEducation.includes("12th")) {
        validateHsc();
        console.log(validateHsc(), "validateHsc();");
        // a = 1;
        if (validateHsc()) {
          a = 0;
        } else {
          a = 1;
        }
      }

      if (selectedEducation.includes("Diploma")) {
        validateDiploma();
        // a = 1;
        if (validateDiploma()) {
          a = 0;
        } else {
          a = 1;
        }
      }
      if (selectedEducation?.includes("UG")) {
        validateInputs();
        // a = 1;

        if (validateInputs()) {
          a = 0;
          ug = 0;
        } else {
          a = 1;
          ug = 1;
        }
      }

      if (selectedEducation.includes("PG")) {
        // validatePg();
        // a = 1;
        if (validatePg()) {
          a = 0;
          pg = 0;
        } else {
          a = 1;
          pg = 1;
        }
      }
    }
    if (
      a == 0 &&
      updateStatus == false &&
      iti == 0 &&
      bacis == 0 &&
      other == 0 &&
      pg == 0 &&
      ug == 0 &&
      (imageFileChange[0] === true ||
        imageFileChange[1] === true ||
        imageFileChange[2] === true ||
        imageFileChange[3] === true ||
        imageFileChange[4] === true ||
        imageFileChange[5] === true)
    ) {
      fetchUploadFiles();
      console.log(
        a == 0 &&
          updateStatus == false &&
          iti == 0 &&
          bacis == 0 &&
          other == 0 &&
          pg == 0 &&
          ug == 0,
        "q98e190283-2813",
        a,
        iti,
        bacis,
        other,
        pg,
      );
    }

    console.log(updateStatus, "klsakklsadklaskdlskld", state.FormsIDList);
    if (a == 0 && state.FormsIDList.EducationID === "") {
      if (
        a == 0 &&
        //  && initState
        //  && state.FormsIDList.EducationID === ""
        updateStatus == true
      ) {
        const formDataUneducated = {
          not_studied: true,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
        };
        dispatch(setEducationDatacreateActions(formDataUneducated));
        setFormDirty(false);
      } else if (
        a == 0 &&
        updateStatus == false &&
        iti == 0 &&
        bacis == 0 &&
        other == 0 &&
        pg == 0 &&
        ug == 0
      ) {
        const payload = {
          // id: state.EducationAction.EducationData.id,
          // data: formData,
          data: EducationCRUD_DATA,
        };
        console.log("Existing educatedupdate");
        dispatch(setEducationDatacreateActions(EducationCRUD_DATA));
      }

      // Educated selection create
      // if ( a == 0 &&  !initState && state.FormsIDList.EducationID === "" && B == 0) {
      //   console.log("Educated selection create");
      //   dispatch(setEducationDatacreateActions(formData));
      //   setFormDirty(false);
      // }
      //  Existing educated update

      // //  Existing educated to non-educated
      // if (
      //   a == 0 &&
      //   (initState &&
      //     state.FormsIDList.EducationID !== "" &&
      //     !state.EducationAction.EducationData.not_studied) ||
      //   updateStatus == state.EducationAction.EducationData.not_studied
      // ) {
      //   const eduCatedToUnedFormData = new FormData();
      //   eduCatedToUnedFormData.append(
      //     "data",
      //     JSON.stringify({
      //       sslc_school_name: "",
      //       sslc_school_place: "",
      //       sslc_year_of_passing: "",
      //       hsc_school_place: "",
      //       hsc_year_of_passing: "",
      //       ug_school_name: "",
      //       ug_school_place: "",
      //       ug_year_of_passing: "",
      //       ug_course_name: "",
      //       ug_branch_name: "",
      //       diploma_school_name: "",
      //       diploma_school_place: "",
      //       diploma_year_of_passing: "",
      //       diploma_branch_name: "",
      //       diploma_course_name: "",
      //       pg_school_name: "",
      //       pg_school_place: "",
      //       pg_branch_name: "",
      //       pg_course_name: "",
      //       pg_year_of_passing: "",
      //       sslc_id: "",
      //       hsc_id: "",
      //       diploma_id: "",
      //       not_studied: true,
      //       PG_id: "",
      //       school_name: "",
      //       standard: "",
      //       year_of_passing: "",
      //       school_place: "",
      //       iti_school_name: "",
      //       iti_school_place: "",
      //       iti_year_of_passing: "",
      //       iti_course_name: "",
      //       iti_branch_name: "",
      //       // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
      //       // timeline_id: state.BasicFormCreated.BasciFormCreate,
      //       timeline_id:
      //         state.BasicFormCreated.BasciFormCreate == ""
      //           ? state.EmployeeProfile.EmployeeProfileList.id
      //           : state.BasicFormCreated.BasciFormCreate,
      //     })
      //   );
      //   const payload = {
      //     id: state.EducationAction.EducationData.id,
      //     data: eduCatedToUnedFormData,
      //   };
      //   console.log("Existing educated to non-educated");
      //   dispatch(setEducationDataPutActions(payload));
      //   setFormDirty(false);
      // }
      // //  Existing non-educated to educated.
      // if (a == 0 &&
      //     state.FormsIDList.EducationID !== ""
      //   // updateStatus != state.EducationAction.EducationData.not_studied
      // ) {
      //   const payload = {
      //     id: state.EducationAction.EducationData.id,
      //     data: formData,
      //   };
      //   dispatch(setEducationDataPutActions(payload));
      //   setFormDirty(false);
      // }
    }

    if (
      (a == 0 &&
        // !initState &&
        state.FormsIDList.EducationID !== "" &&
        B == 0 &&
        iti == 0 &&
        bacis == 0 &&
        other == 0 &&
        pg == 0 &&
        ug == 0 &&
        state.FormsIDList.EducationID !== "" &&
        updateStatus != state.EducationAction.EducationData.not_studied) ||
      data.sslc_school_name !=
        state.EducationAction.EducationData.sslc_school_name ||
      data.sslc_school_place !=
        state.EducationAction.EducationData.sslc_school_place ||
      data.sslc_year_of_passing !=
        state.EducationAction.EducationData.sslc_year_of_passing ||
      data.hsc_school_name !=
        state.EducationAction.EducationData.hsc_school_name ||
      data.hsc_school_place !=
        state.EducationAction.EducationData.hsc_school_place ||
      data.hsc_year_of_passing !=
        state.EducationAction.EducationData.hsc_year_of_passing ||
      data.ug_school_name !=
        state.EducationAction.EducationData.ug_school_name ||
      data.ug_school_place !=
        state.EducationAction.EducationData.ug_school_place ||
      data.ug_year_of_passing !=
        state.EducationAction.EducationData.ug_year_of_passing ||
      data.ug_course_name !=
        state.EducationAction.EducationData.ug_course_name ||
      data.ug_branch_name !=
        state.EducationAction.EducationData.ug_branch_name ||
      data.diploma_school_name !=
        state.EducationAction.EducationData.diploma_school_name ||
      data.diploma_school_place !=
        state.EducationAction.EducationData.diploma_school_place ||
      data.diploma_year_of_passing !=
        state.EducationAction.EducationData.diploma_year_of_passing ||
      data.diploma_branch_name !=
        state.EducationAction.EducationData.diploma_branch_name ||
      data.diploma_course_name !=
        state.EducationAction.EducationData.diploma_course_name ||
      data.pg_school_name !=
        state.EducationAction.EducationData.pg_school_name ||
      data.pg_school_place !=
        state.EducationAction.EducationData.pg_school_place ||
      data.pg_branch_name !=
        state.EducationAction.EducationData.pg_branch_name ||
      data.pg_course_name !=
        state.EducationAction.EducationData.pg_course_name ||
      data.pg_year_of_passing !=
        state.EducationAction.EducationData.pg_year_of_passing ||
      data.school_name != state.EducationAction.EducationData.school_name ||
      data.standard != state.EducationAction.EducationData.standard ||
      data.school_place != state.EducationAction.EducationData.school_place ||
      data.year_of_passing !=
        state.EducationAction.EducationData.year_of_passing ||
      data.iti_school_name !=
        state.EducationAction.EducationData.iti_school_name ||
      data.iti_school_place !=
        state.EducationAction.EducationData.iti_school_place ||
      data.iti_year_of_passing !=
        state.EducationAction.EducationData.iti_year_of_passing ||
      data.iti_course_name !=
        state.EducationAction.EducationData.iti_course_name ||
      data.iti_branch_name !=
        state.EducationAction.EducationData.iti_branch_name ||
      hasMismatch
    ) {
      if (
        a == 0 &&
        // !initState &&
        state.FormsIDList.EducationID !== "" &&
        B == 0 &&
        iti == 0 &&
        bacis == 0 &&
        other == 0 &&
        pg == 0 &&
        ug == 0
        // !state.EducationAction.EducationData.not_studied
      ) {
        const payload = {
          id: state.EducationAction.EducationData.id,
          // data: formData,
          data: EducationCRUD_DATA,
        };
        dispatch(setEducationDataPutActions(payload));
        // setFormDirty(false);
      }
    } else if (
      a == 0 &&
      // !initState &&
      state.FormsIDList.EducationID !== "" &&
      B == 0 &&
      iti == 0 &&
      bacis == 0 &&
      other == 0 &&
      pg == 0 &&
      ug == 0 &&
      state.FormsIDList.EducationID !== "" &&
      updateStatus == state.EducationAction.EducationData.not_studied &&
      data.sslc_school_name ==
        state.EducationAction.EducationData.sslc_school_name &&
      data.sslc_school_place ==
        state.EducationAction.EducationData.sslc_school_place &&
      data.sslc_year_of_passing ==
        state.EducationAction.EducationData.sslc_year_of_passing &&
      data.hsc_school_name ==
        state.EducationAction.EducationData.hsc_school_name &&
      data.hsc_school_place ==
        state.EducationAction.EducationData.hsc_school_place &&
      data.hsc_year_of_passing ==
        state.EducationAction.EducationData.hsc_year_of_passing &&
      data.ug_school_name ==
        state.EducationAction.EducationData.ug_school_name &&
      data.ug_school_place ==
        state.EducationAction.EducationData.ug_school_place &&
      data.ug_year_of_passing ==
        state.EducationAction.EducationData.ug_year_of_passing &&
      data.ug_course_name ==
        state.EducationAction.EducationData.ug_course_name &&
      data.ug_branch_name ==
        state.EducationAction.EducationData.ug_branch_name &&
      data.diploma_school_name ==
        state.EducationAction.EducationData.diploma_school_name &&
      data.diploma_school_place ==
        state.EducationAction.EducationData.diploma_school_place &&
      data.diploma_year_of_passing ==
        state.EducationAction.EducationData.diploma_year_of_passing &&
      data.diploma_branch_name ==
        state.EducationAction.EducationData.diploma_branch_name &&
      data.diploma_course_name ==
        state.EducationAction.EducationData.diploma_course_name &&
      data.pg_school_name ==
        state.EducationAction.EducationData.pg_school_name &&
      data.pg_school_place ==
        state.EducationAction.EducationData.pg_school_place &&
      data.pg_branch_name ==
        state.EducationAction.EducationData.pg_branch_name &&
      data.pg_course_name ==
        state.EducationAction.EducationData.pg_course_name &&
      data.pg_year_of_passing ==
        state.EducationAction.EducationData.pg_year_of_passing &&
      data.school_name == state.EducationAction.EducationData.school_name &&
      data.standard == state.EducationAction.EducationData.standard &&
      data.school_place == state.EducationAction.EducationData.school_place &&
      data.year_of_passing ==
        state.EducationAction.EducationData.year_of_passing &&
      data.iti_school_name ==
        state.EducationAction.EducationData.iti_school_name &&
      data.iti_school_place ==
        state.EducationAction.EducationData.iti_school_place &&
      data.iti_year_of_passing ==
        state.EducationAction.EducationData.iti_year_of_passing &&
      data.iti_course_name ==
        state.EducationAction.EducationData.iti_course_name &&
      data.iti_branch_name ==
        state.EducationAction.EducationData.iti_branch_name &&
      hasMismatch == false
    ) {
      dispatch(SetActiveTabs(6));
    }

    // else if (
    //   formDirty === false
    //  &&
    //   state.FormsIDList.EducationID === ""
    //   // updateStatus == state.EducationAction.EducationData.not_studied
    // ) {
    //   dispatch(SetActiveTabs(6));
    // }
  };

  console.log(
    data,
    state.EducationAction.EducationData,
    "sadhlaskjdstate.EducationAction.EducationData",
    hasMismatch,
  );

  const getFilePreview = (fileData) => {
    if (!fileData) return null;

    const value = fileData.toLowerCase();
    console.log(value, "kalsdkaksldkla", value.endsWith(".pdf"));

    if (value.endsWith(".pdf")) return pdfIcon;
    if (value.endsWith(".xls") || value.endsWith(".xlsx")) return excelIcon;

    return fileData; // image base64
  };

  return (
    <>
      <div>
        <div>
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>Education Details</span>
                        </div>
                      </div>

                      {/* 
                          <>
                            <div className="row">
                              <div
                                className="col-10"
                                style={{
                                  paddingLeft: "25px",
                                  paddingTop: "13px",
                                }}
                              >
                                <Checkbox
                                  checked={
                                    updateStatus
                                    // ? updateStatus
                                    // : state.EducationAction.EducationData
                                    //     .not_studied
                                  }
                                  onClick={() => {
                                    if (state.NumberCounts.Editable !== 1 || state.ClientBranchIDs.SUBROLE != 3) {
                                      setUpdateStatus(false);
                                      setInitState(!initState);
                                    }
                                  }}
                                  disabled={
                                    state.NumberCounts.Editable == 1 ||
                                    state.ClientBranchIDs.SUBROLE != 3 ?

                                    true :
                                    false
                                  }
                                />
                                <span style={{ textAlign: "center" }}>
                                  Skip{" "}
                                </span>
                              </div>
                              <div className="col-2">
                                <div
                                  className="noEducationDiv"
                                  onClick={() => {
                                    toast.warning(
                                      "Please uncheck to select education.",
                                      {
                                        position: toast.POSITION.TOP_RIGHT,
                                      }
                                    );  
                                  }}
                                >
                                  <span>Select Education</span>
                                  <p>v</p>
                                </div>
                              </div>
                            </div>
                          </> */}

                      <>
                        {/* {state.NumberCounts.Editable !== 1 ||( state.ClientBranchIDs.SUBROLE == 3 )&& ( */}
                        {organization?.organization?.id !==
                          "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <div className="row">
                            <div
                              className="col-12"
                              style={{
                                paddingLeft: "25px",
                                paddingTop: "13px",
                                marginBottom: "19px",
                              }}
                            >
                              <Checkbox
                                checked={updateStatus}
                                onChange={() => {
                                  setUpdateStatus(!updateStatus);
                                  setInitState(!initState);
                                  setFormDirty(true);
                                  setData(initialState);
                                  setEducationOptions([
                                    // { value: "SSLC", label: "SSLC" },
                                    // { value: "HSC", label: "HSC" },
                                    { value: "10th", label: "10th" },
                                    { value: "12th", label: "12th" },

                                    { value: "ITI", label: "ITI" },

                                    { value: "Diploma", label: "Diploma" },
                                    { value: "UG", label: "UG" },
                                    { value: "PG", label: "PG" },
                                    { value: "OTHER", label: "OTHER" },
                                  ]);
                                  setSelectionErr("");
                                  setSelectedEducation([]);
                                  setImages([
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                  ]);
                                  setImagesFile([null, null, null, null, null]);
                                  setPresentImages([
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                  ]);
                                }}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                style={{ width: "12px", marginRight: "12px" }}
                              />
                              <span
                                style={{
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                {/* Choose 'no degree' if applicable. */}
                                Skip
                              </span>
                            </div>
                          </div>
                        )}
                        {/* //  )} */}
                        {/* {state.NumberCounts.Editable !== 1 || ( state.ClientBranchIDs.SUBROLE == 3 )&& ( */}

                        {!updateStatus ||
                        organization?.organization?.id ==
                          "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ? (
                          <>
                            <div className="educationHeadDiv">
                              <Select
                                options={
                                  educationOptions.length !== 0
                                    ? educationOptions
                                    : [
                                        {
                                          value: "noneSelected",
                                          label: "None",
                                          isDisabled: true,
                                        },
                                      ]
                                }
                                value={
                                  educationOptions.length !== 0
                                    ? {
                                        value: "Select Education",
                                        label: "Select Education",
                                      }
                                    : {
                                        value: "No items to selected",
                                        label: "No items to selected",
                                      }
                                }
                                onChange={(selectedOption) => {
                                  setUpdateStatus(false);
                                  setSelectionErr("");
                                  handleEducationChange(selectedOption.value);
                                }}
                                isDisabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                placeholder="Select Education"
                              />
                            </div>
                            <p className="Error" style={{ marginLeft: "5px" }}>
                              {SelectionErr}
                            </p>
                          </>
                        ) : null}
                        {/* )} */}
                      </>

                      {!updateStatus ? (
                        <>
                          <div className="Modal-Body ModalForms">
                            {/* SSLC */}
                            {data.sslc_school_name?.length !== 0 ||
                            data.sslc_school_place?.length !== 0 ||
                            data.sslc_year_of_passing?.length !== 0 ||
                            selectedEducation.includes("10th") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {/* SSLC */}
                                      10th
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation(
                                            "10th",
                                            "sslc_",
                                            // "10th_"
                                          );
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {sslcTemplate.map((row, rowIndex) => (
                                    <>
                                      {row.map((input, inputIndex) => (
                                        // console.log(inputIndex, "jalsfdjlskdfjs")
                                        <>
                                          <div
                                            className="col-sm-3 mt-3"
                                            // className="col-6 mt-4"
                                            key={inputIndex}
                                          >
                                            <label
                                              htmlFor={`validationCustom${
                                                inputIndex + 1
                                              }`}
                                              className="form-label"
                                            >
                                              {input.label}
                                              {(!isAthena ||
                                                input.name !==
                                                  "sslc_school_name") && (
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              type={
                                                rowIndex === 1 &&
                                                inputIndex === 0
                                                  ? // ? "number"
                                                    "number"
                                                  : "text"
                                              }
                                              className="form-control"
                                              // required={
                                              //   input.label === "Institute Place"
                                              // }
                                              autoComplete="off"
                                              value={input.value}
                                              name={input.name}
                                              // readOnly
                                              readOnly={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              disabled={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              // max={
                                              //   input.label ===
                                              //   "10th Year Of Passing"
                                              //     ? "4"
                                              //     : undefined
                                              // }
                                              // min={
                                              //   // rowIndex === 1 && inputIndex === 0
                                              //   input.label ===
                                              //   "10th Year Of Passing"
                                              //     ? "4"
                                              //     : undefined
                                              // }
                                              step="1"
                                              //                                           onKeyDown={(evt) => {
                                              //                                             if (                                             rowIndex === 1 && inputIndex === 0
                                              // &&                                              ["e", "E", "+", "-", "."].includes(evt.key)) {
                                              //                                               evt.preventDefault();
                                              //                                             }
                                              //                                           }}
                                              ref={inputRef}
                                              onKeyDown={(evt) => {
                                                if (
                                                  rowIndex === 1 &&
                                                  inputIndex === 0
                                                ) {
                                                  preventZoom(evt);
                                                }
                                              }}
                                              onPaste={(evt) => {
                                                if (
                                                  rowIndex === 1 &&
                                                  inputIndex === 0
                                                ) {
                                                  handlePaste(evt); // Add your handlePaste logic here
                                                }
                                              }}
                                              onWheel={(evt) => {
                                                if (
                                                  rowIndex === 1 &&
                                                  inputIndex === 0
                                                ) {
                                                  preventZoom(evt); // Add your preventZoom logic here
                                                }
                                              }}
                                              maxLength={
                                                input.label ===
                                                "10th Year Of Passing"
                                                  ? 4
                                                  : undefined
                                              }
                                              onChange={(e) => {
                                                // HandleChanges(e);
                                                const value = e.target.value;
                                                if (
                                                  input.label ===
                                                    "10th Year Of Passing" &&
                                                  value.length > 4
                                                ) {
                                                  // toast.error(
                                                  //   "Year of Passing cannot exceed 4 characters",
                                                  //   {
                                                  //     position:
                                                  //       toast.POSITION.TOP_RIGHT,
                                                  //   }
                                                  // );
                                                } else {
                                                  // Update the input value as needed

                                                  HandleChanges(e);
                                                  switch (input.name) {
                                                    case "sslc_school_name":
                                                      setSslcSchoolName(value);
                                                      break;
                                                    case "sslc_school_place":
                                                      setSslcSchoolPlace(value);
                                                      break;
                                                    case "sslc_year_of_passing":
                                                      setSslcYearOfPassing(
                                                        value,
                                                      );
                                                      break;
                                                    default:
                                                      break;
                                                  }

                                                  // Clear the error for the specific field

                                                  setSslcErr((prev) => ({
                                                    ...prev,
                                                    [input.name]: "",
                                                  }));
                                                }
                                              }}
                                            />

                                            {sslcErr[input.name] && (
                                              <span style={{ color: "red" }}>
                                                {sslcErr[input.name]}
                                              </span>
                                            )}
                                          </div>
                                        </>
                                      ))}
                                    </>
                                  ))}
                                  <div className="row">
                                    <div
                                      className="col mt-3 centerElement"
                                      style={{ marginLeft: "15px" }}
                                    >
                                      <label>
                                        File
                                        <small
                                          style={{
                                            color: "red",
                                            marginLeft: "12px",
                                            display: "block",
                                          }}
                                        >
                                          Note:Upload the picture, please.
                                          Verify that the file is in the JPG,
                                          JPEG,PNG,PDF AND SHEET format and that
                                          its size is less than 10 MB.
                                        </small>
                                      </label>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        {console.log(
                                          images,
                                          "daskldalkdklaskldkak",
                                        )}
                                        {images[0] && (
                                          <img
                                            src={getFilePreview(images[0])}
                                            alt="test2"
                                            style={{
                                              width: "150px",
                                              height: "150px",
                                              // border: "1px solid #000",
                                              borderRadius: "10px",
                                            }}
                                          />
                                        )}

                                        <Button
                                          // className={classes.customButton}
                                          component="label"
                                          role={undefined}
                                          className="doctorupload"
                                          variant="contained"
                                          tabIndex={-1}
                                          startIcon={<CloudUploadIcon />}
                                          sx={{
                                            backgroundColor: "#ef4d39",
                                            fontSize: "11px !important",
                                            "&:hover": {
                                              backgroundColor: "#e74c3c",
                                              opacity: "0.8",
                                            },
                                          }}
                                          onChange={(e) => {
                                            setforindex(0);
                                            handleFileChange(e, 0);
                                          }}
                                        >
                                          {images[0]
                                            ? "Update Image"
                                            : "Upload file"}

                                          <VisuallyHiddenInput
                                            type="file"
                                            ref={fileInputRef}
                                          />
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {/* ITI */}

                            {data.hsc_school_name?.length !== 0 ||
                            data.hsc_school_place?.length !== 0 ||
                            data.hsc_year_of_passing?.length !== 0 ||
                            selectedEducation.includes("12th") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      12th
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation(
                                            "12th",
                                            // "12th_"
                                            "hsc_",
                                          );
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {/* <div
                                 className="col-12"
                                 style={{ marginTop: "30px" }}
                               >
                                 <label>HSC</label>
                               </div> */}
                                  <div className="col-sm-3 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      12th School Name
                                      {!isAthena && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="hsc_school_name"
                                      value={data.hsc_school_name}
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        HandleChanges(e);

                                        setHscErr((prevErr) => ({
                                          ...prevErr,
                                          [e.target.name]: "",
                                        }));
                                      }}
                                      disabled={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                    />

                                    {hscErr.hsc_school_name && (
                                      <span style={{ color: "red" }}>
                                        {hscErr.hsc_school_name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-sm-3 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      12th School Place
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.hsc_school_place}
                                      name="hsc_school_place"
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      disabled={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setHscErr((prevErr) => ({
                                          ...prevErr,
                                          [e.target.name]: "",
                                        }));
                                      }}
                                    />

                                    {hscErr.hsc_school_place && (
                                      <span style={{ color: "red" }}>
                                        {hscErr.hsc_school_place}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-sm-3 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      12th Year Of Passing
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="number"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.hsc_year_of_passing}
                                      step="1"
                                      ref={inputRef}
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => {
                                        handlePaste(evt); // Add your handlePaste logic here
                                      }}
                                      onWheel={(evt) => {
                                        preventZoom(evt); // Add your preventZoom logic here
                                      }}
                                      name="hsc_year_of_passing"
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        // HandleChanges(e);
                                        const value = e.target.value;
                                        if (
                                          // input.label ===
                                          //   "10th Year Of Passing" &&
                                          value.length > 4
                                        ) {
                                          // toast.error(
                                          //   "Year of Passing cannot exceed 4 characters",
                                          //   {
                                          //     position:
                                          //       toast.POSITION.TOP_RIGHT,
                                          //   }
                                          // );
                                        } else {
                                          // Update the input value as needed

                                          HandleChanges(e);
                                          setHscErr((prevErr) => ({
                                            ...prevErr,
                                            [e.target.name]: "",
                                          }));
                                        }
                                      }}
                                      disabled={
                                        state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                      // max="4"
                                      // maxLength={"4"}
                                    />
                                    {hscErr.hsc_year_of_passing && (
                                      <span style={{ color: "red" }}>
                                        {hscErr.hsc_year_of_passing}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-6 mt-3 centerElement">
                                    <label>
                                      File
                                      <small
                                        style={{
                                          color: "red",
                                          marginLeft: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Note:Upload the picture, please. Verify
                                        that the file is in the JPG,
                                        JPEG,PNG,PDF AND SHEET format and that
                                        its size is less than 10 MB.
                                      </small>
                                    </label>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      {images[1] && (
                                        <img
                                          src={getFilePreview(images[1])}
                                          alt="test2"
                                          style={{
                                            width: "150px",
                                            height: "150px",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      )}
                                      {state.NumberCounts.Editable != 1 ||
                                      state.ClientBranchIDs.SUBROLE == 3 ? (
                                        <Button
                                          // className={classes.customButton}
                                          className="doctorupload"
                                          component="label"
                                          role={undefined}
                                          variant="contained"
                                          tabIndex={-1}
                                          startIcon={<CloudUploadIcon />}
                                          sx={{
                                            backgroundColor: "#ef4d39",
                                            fontSize: "11px !important",
                                            "&:hover": {
                                              // backgroundColor: "green",
                                              backgroundColor: "#e74c3c",

                                              opacity: "0.8",
                                            },
                                          }}
                                          onChange={(e) => {
                                            setforindex(1);
                                            handleFileChange(e, 1);

                                            // setFileErr("");
                                          }}
                                        >
                                          {images[1]
                                            ? "Update Image"
                                            : "Upload file"}

                                          <VisuallyHiddenInput
                                            type="file"
                                            ref={fileInputRef}
                                          />
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {data.iti_branch_name?.length !== 0 ||
                            data.iti_course_name?.length !== 0 ||
                            data.iti_school_name?.length !== 0 ||
                            data.iti_school_place?.length !== 0 ||
                            selectedEducation.includes("ITI") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      ITI
                                    </label>
                                    {/* {state.NumberCounts.Editable !== 1 && ( */}
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation("ITI", "iti_");
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {ITIGraduationTemplate.map(
                                    (row, rowIndex) => (
                                      <>
                                        {row.map((input, inputIndex) => (
                                          <>
                                            <div
                                              className="col-sm-3 mt-3"
                                              key={inputIndex}
                                            >
                                              <label
                                                htmlFor={`validationCustom${
                                                  inputIndex + 1
                                                }`}
                                                className="form-label"
                                              >
                                                {input.label}
                                                {(!isAthena ||
                                                  input.name !==
                                                    "iti_school_name") && (
                                                  <span style={{ color: "red" }}>
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                // type="text"
                                                type={
                                                  // rowIndex === 3 && inputIndex === 4
                                                  input.label ==
                                                  "ITI Year Of Passing"
                                                    ? "number"
                                                    : "text"
                                                }
                                                className="form-control"
                                                required={
                                                  input.label ===
                                                  "Institute Place"
                                                }
                                                step="1"
                                                onKeyDown={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "ITI Year Of Passing"
                                                  ) {
                                                    preventZoom(evt);
                                                  }
                                                }}
                                                ref={inputRef}
                                                onPaste={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "ITI Year Of Passing"
                                                  ) {
                                                    handlePaste(evt); // Add your handlePaste logic here
                                                  }
                                                }}
                                                onWheel={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "ITI Year Of Passing"
                                                  ) {
                                                    preventZoom(evt); // Add your preventZoom logic here
                                                  }
                                                }}
                                                autoComplete="off"
                                                value={input.value}
                                                name={input.name}
                                                // readOnly
                                                readOnly={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                disabled={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                onChange={(e) => {
                                                  // HandleChanges(e);

                                                  const value = e.target.value;
                                                  if (
                                                    input.label ===
                                                      "ITI Year Of Passing" &&
                                                    value.length > 4
                                                  ) {
                                                    // toast.error(
                                                    //   "Year of Passing cannot exceed 4 characters",
                                                    //   {
                                                    //     position:
                                                    //       toast.POSITION.TOP_RIGHT,
                                                    //   }
                                                    // );
                                                  } else {
                                                    // Update the input value as needed

                                                    HandleChanges(e);

                                                    switch (input.name) {
                                                      case "iti_branch_name":
                                                        setItiBranchName(value);
                                                        break;
                                                      case "iti_course_name":
                                                        setItiCourseName(value);
                                                        break;
                                                      case "iti_school_name":
                                                        setItiSchoolName(value);
                                                        break;
                                                      case "iti_school_place":
                                                        setItiSchoolPlace(
                                                          value,
                                                        );
                                                        break;
                                                      case "iti_year_of_passing":
                                                        setItiYearOfPassing(
                                                          value,
                                                        );
                                                        break;
                                                      default:
                                                        break;
                                                    }

                                                    // Clear the error for the specific field
                                                    setItiErr((prev) => ({
                                                      ...prev,
                                                      [input.name]: "",
                                                    }));
                                                  }
                                                }}
                                              />

                                              {itiErr[input.name] && (
                                                <span style={{ color: "red" }}>
                                                  {itiErr[input.name]}
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        ))}
                                      </>
                                    ),
                                  )}
                                  <div className="col">
                                    <div className="col-6 mt-3 centerElement">
                                      <label>
                                        File
                                        <small
                                          style={{
                                            color: "red",
                                            marginLeft: "12px",
                                            display: "block",
                                          }}
                                        >
                                          Note:Upload the picture, please.
                                          Verify that the file is in the JPG,
                                          JPEG,PNG,PDF AND SHEET format and that
                                          its size is less than 10 MB.
                                        </small>
                                      </label>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        {images[5] && (
                                          <img
                                            src={getFilePreview(images[5])}
                                            alt="test2"
                                            style={{
                                              width: "150px",
                                              height: "150px",
                                              borderRadius: "10px",
                                            }}
                                          />
                                        )}
                                        {state.NumberCounts.Editable != 1 ||
                                        state.ClientBranchIDs.SUBROLE == 3 ? (
                                          <Button
                                            // className={classes.customButton}
                                            component="label"
                                            role={undefined}
                                            className="doctorupload"
                                            variant="contained"
                                            tabIndex={-1}
                                            startIcon={<CloudUploadIcon />}
                                            sx={{
                                              backgroundColor: "#ef4d39",
                                              fontSize: "11px !important",
                                              "&:hover": {
                                                // backgroundColor: "green",
                                                backgroundColor: "#e74c3c",

                                                opacity: "0.8",
                                              },
                                            }}
                                            onChange={(e) => {
                                              setforindex(5);
                                              handleFileChange(e, 5);

                                              // setFileErr("");
                                            }}
                                          >
                                            {images[5]
                                              ? "Update Image"
                                              : "Upload file"}
                                            <VisuallyHiddenInput
                                              type="file"
                                              ref={fileInputRef}
                                            />
                                          </Button>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {/* OTHERS */}

                            {/* HSC */}

                            {/* Diploma */}
                            {data.diploma_branch_name?.length !== 0 ||
                            data.diploma_course_name?.length !== 0 ||
                            data.diploma_school_name?.length !== 0 ||
                            data.diploma_school_place?.length !== 0 ||
                            selectedEducation.includes("Diploma") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Diploma
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation(
                                            "Diploma",
                                            "diploma_",
                                          );
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {diplomaTemplate.map((row, rowIndex) => (
                                    <>
                                      {row.map((input, inputIndex) => (
                                        <>
                                          <div
                                            className="col-sm-3 mt-3"
                                            key={inputIndex}
                                          >
                                            <label
                                              htmlFor={`validationCustom${
                                                inputIndex + 1
                                              }`}
                                              className="form-label"
                                            >
                                              {input.label}
                                              {(!isAthena ||
                                                input.name !==
                                                  "diploma_school_name") && (
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              // type="text"
                                              type={
                                                // rowIndex === 3 && inputIndex === 4
                                                input.label == "Year Of Passout"
                                                  ? "number"
                                                  : "text"
                                              }
                                              className="form-control"
                                              required={
                                                input.label ===
                                                "Institute Place"
                                              }
                                              autoComplete="off"
                                              value={input.value}
                                              name={input.name}
                                              // readOnly
                                              readOnly={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              step="1"
                                              ref={inputRef}
                                              onKeyDown={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  preventZoom(evt);
                                                }
                                              }}
                                              onPaste={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  handlePaste(evt); // Add your handlePaste logic here
                                                }
                                              }}
                                              onWheel={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  preventZoom(evt); // Add your preventZoom logic here
                                                }
                                              }}
                                              disabled={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              // onChange={(e) => {
                                              //   HandleChanges(e);

                                              //   setDiplomaErr(prevErrors => ({
                                              //     ...prevErrors,
                                              //     [input.name]: '', // Clear the error for the specific input field
                                              //   }));

                                              // }}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                if (
                                                  input.label ===
                                                    "Year Of Passout" &&
                                                  value.length > 4
                                                ) {
                                                } else {
                                                  HandleChanges(e);

                                                  setDiplomaErr(
                                                    (prevErrors) => ({
                                                      ...prevErrors,
                                                      [input.name]: "", // Clear the error for the specific input field
                                                    }),
                                                  );
                                                }
                                              }}
                                            />

                                            {diplomaErr[input.name] && (
                                              <span style={{ color: "red" }}>
                                                {diplomaErr[input.name]}
                                              </span>
                                            )}
                                          </div>
                                        </>
                                      ))}
                                    </>
                                  ))}
                                </div>
                                <div className="row">
                                  <div className="col-6 mt-3 centerElement">
                                    <label>
                                      File
                                      <small
                                        style={{
                                          color: "red",
                                          marginLeft: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Note:Upload the picture, please. Verify
                                        that the file is in the JPG,
                                        JPEG,PNG,PDF AND SHEET format and that
                                        its size is less than 10 MB.
                                      </small>
                                    </label>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      {images[2] && (
                                        <img
                                          src={getFilePreview(images[2])}
                                          alt="test2"
                                          style={{
                                            width: "150px",
                                            height: "150px",
                                            borderRadius: "10px",
                                            border: "1px solid #000",
                                          }}
                                        />
                                      )}
                                      {state.NumberCounts.Editable != 1 ||
                                      state.ClientBranchIDs.SUBROLE == 3 ? (
                                        <Button
                                          // className={classes.customButton}
                                          className="doctorupload"
                                          component="label"
                                          role={undefined}
                                          variant="contained"
                                          tabIndex={-1}
                                          startIcon={<CloudUploadIcon />}
                                          sx={{
                                            backgroundColor: "#ef4d39",
                                            fontSize: "11px !important",
                                            "&:hover": {
                                              // backgroundColor: "green",
                                              backgroundColor: "#e74c3c",

                                              opacity: "0.8",
                                            },
                                          }}
                                          onChange={(e) => {
                                            setforindex(2);
                                            handleFileChange(e, 2);

                                            // setFileErr("");
                                          }}
                                        >
                                          {images[2]
                                            ? "Update Image"
                                            : "Upload file"}

                                          <VisuallyHiddenInput
                                            type="file"
                                            ref={fileInputRef}
                                          />
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {/* Under Graduation */}
                            {data?.ug_branch_name?.length !== 0 ||
                            data?.ug_course_name?.length !== 0 ||
                            data?.ug_school_name?.length !== 0 ||
                            data?.ug_school_place?.length !== 0 ||
                            selectedEducation?.includes("UG") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      UG
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation("UG", "ug_");
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {ugTemplate.map((row, rowIndex) => (
                                    <>
                                      {row.map((input, inputIndex) => (
                                        <>
                                          <div
                                            className="col-sm-3 mt-3"
                                            key={inputIndex}
                                          >
                                            <label
                                              htmlFor={`validationCustom${
                                                inputIndex + 1
                                              }`}
                                              className="form-label"
                                            >
                                              {input.label}
                                              {(!isAthena ||
                                                input.name !==
                                                  "ug_school_name") && (
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              type={
                                                input.label == "Year Of Passout"
                                                  ? "number"
                                                  : "text"
                                              }
                                              className="form-control"
                                              required={
                                                input.label ===
                                                "Institute Place"
                                              }
                                              step="1"
                                              ref={inputRef}
                                              onKeyDown={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  preventZoom(evt);
                                                }
                                              }}
                                              onPaste={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  handlePaste(evt); // Add your handlePaste logic here
                                                }
                                              }}
                                              onWheel={(evt) => {
                                                if (
                                                  input.label ==
                                                  "Year Of Passout"
                                                ) {
                                                  preventZoom(evt); // Add your preventZoom logic here
                                                }
                                              }}
                                              autoComplete="off"
                                              value={input.value}
                                              name={input.name}
                                              // readOnly
                                              readOnly={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              disabled={
                                                state.NumberCounts.Editable ==
                                                  1 &&
                                                state.ClientBranchIDs.SUBROLE !=
                                                  3
                                                  ? true
                                                  : false
                                              }
                                              // onChange={(e) => {

                                              //   setUgErr((prevErr) => ({
                                              //     ...prevErr,
                                              //     [input.name]: '',
                                              //   }));

                                              // }}

                                              onChange={(e) => {
                                                const value = e.target.value;
                                                if (
                                                  input.label ===
                                                    "Year Of Passout" &&
                                                  value.length > 4
                                                ) {
                                                } else {
                                                  HandleChanges(e);

                                                  setUgErr((prevErr) => ({
                                                    ...prevErr,
                                                    [input.name]: "",
                                                  }));
                                                }
                                              }}
                                            />
                                            {ugErr[input.name] && (
                                              <span style={{ color: "red" }}>
                                                {ugErr[input.name]}
                                              </span>
                                            )}
                                          </div>
                                        </>
                                      ))}
                                    </>
                                  ))}
                                </div>
                                <div className="row">
                                  <div className="col-6 mt-3 centerElement">
                                    <label>
                                      File
                                      <small
                                        style={{
                                          color: "red",
                                          marginLeft: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Note:Upload the picture, please. Verify
                                        that the file is in the JPG,
                                        JPEG,PNG,PDF AND SHEET format and that
                                        its size is less than 10 MB.
                                      </small>
                                    </label>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      {images[3] && (
                                        <img
                                          src={getFilePreview(images[3])}
                                          alt="test2"
                                          style={{
                                            width: "150px",
                                            height: "150px",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      )}
                                      {state.NumberCounts.Editable != 1 ||
                                      state.ClientBranchIDs.SUBROLE == 3 ? (
                                        <Button
                                          // className={classes.customButton}
                                          className="doctorupload"
                                          component="label"
                                          role={undefined}
                                          variant="contained"
                                          tabIndex={-1}
                                          startIcon={<CloudUploadIcon />}
                                          sx={{
                                            backgroundColor: "#ef4d39",
                                            fontSize: "11px !important",
                                            "&:hover": {
                                              // backgroundColor: "green",
                                              backgroundColor: "#e74c3c",

                                              opacity: "0.8",
                                            },
                                          }}
                                          onChange={(e) => {
                                            setforindex(3);
                                            handleFileChange(e, 3);

                                            // setFileErr("");
                                          }}
                                        >
                                          {images[3]
                                            ? "Update Image"
                                            : "Upload file"}

                                          <VisuallyHiddenInput
                                            type="file"
                                            ref={fileInputRef}
                                          />
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {/* Post Graduation */}
                            {data.pg_branch_name?.length !== 0 ||
                            data.pg_course_name?.length !== 0 ||
                            data.pg_school_name?.length !== 0 ||
                            data.pg_school_place?.length !== 0 ||
                            selectedEducation.includes("PG") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      PG
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ||
                                    state.ClientBranchIDs.SUBROLE == 3 ? (
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation("PG", "pg_");
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {postGraduationTemplate.map(
                                    (row, rowIndex) => (
                                      <>
                                        {row.map((input, inputIndex) => (
                                          <>
                                            <div
                                              className="col-sm-3 mt-3"
                                              key={inputIndex}
                                            >
                                              <label
                                                htmlFor={`validationCustom${
                                                  inputIndex + 1
                                                }`}
                                                className="form-label"
                                              >
                                                {input.label}
                                                {(!isAthena ||
                                                  input.name !==
                                                    "pg_school_name") && (
                                                  <span style={{ color: "red" }}>
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                type={
                                                  // rowIndex === 3 && inputIndex === 4
                                                  input.label ==
                                                  "Year Of Passout"
                                                    ? "number"
                                                    : "text"
                                                }
                                                className="form-control"
                                                required={
                                                  input.label ===
                                                  "Institute Place"
                                                }
                                                step="1"
                                                ref={inputRef}
                                                onKeyDown={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year Of Passout"
                                                  ) {
                                                    preventZoom(evt);
                                                  }
                                                }}
                                                onPaste={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year Of Passout"
                                                  ) {
                                                    handlePaste(evt); // Add your handlePaste logic here
                                                  }
                                                }}
                                                onWheel={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year Of Passout"
                                                  ) {
                                                    preventZoom(evt); // Add your preventZoom logic here
                                                  }
                                                }}
                                                autoComplete="off"
                                                value={input.value}
                                                name={input.name}
                                                // readOnly
                                                readOnly={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                disabled={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                //  onChange={(e) => {
                                                //    HandleChanges(e);
                                                //    setPgErr((prevErr) => ({
                                                //      ...prevErr,
                                                //      [input.name]: '',
                                                //    }));

                                                //  }}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  if (
                                                    input.label ===
                                                      "Year Of Passout" &&
                                                    value.length > 4
                                                  ) {
                                                  } else {
                                                    HandleChanges(e);

                                                    setPgErr((prevErr) => ({
                                                      ...prevErr,
                                                      [input.name]: "",
                                                    }));
                                                  }
                                                }}
                                              />

                                              {pgErr[input.name] && (
                                                <span style={{ color: "red" }}>
                                                  {pgErr[input.name]}
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        ))}
                                      </>
                                    ),
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-6 mt-3 centerElement">
                                    <label>File</label>
                                    <small
                                      style={{
                                        color: "red",
                                        marginLeft: "12px",
                                        display: "block",
                                      }}
                                    >
                                      Note:Upload the picture, please. Verify
                                      that the file is in the JPG, JPEG,PNG,PDF
                                      AND SHEET format and that its size is less
                                      than 10 MB.
                                    </small>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      {images[4] && (
                                        <img
                                          src={getFilePreview(images[4])}
                                          alt="test2"
                                          style={{
                                            // border: "1px solid #000",
                                            width: "150px",
                                            height: "150px",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      )}
                                      {state.NumberCounts.Editable != 1 ||
                                      state.ClientBranchIDs.SUBROLE == 3 ? (
                                        <Button
                                          // className={classes.customButton}
                                          className="doctorupload"
                                          component="label"
                                          role={undefined}
                                          variant="contained"
                                          tabIndex={-1}
                                          startIcon={<CloudUploadIcon />}
                                          sx={{
                                            backgroundColor: "#ef4d39",
                                            fontSize: "11px !important",
                                            "&:hover": {
                                              // backgroundColor: "green",
                                              backgroundColor: "#e74c3c",

                                              opacity: "0.8",
                                            },
                                          }}
                                          onChange={(e) => {
                                            setforindex(4);
                                            handleFileChange(e, 4);

                                            // setFileErr("");
                                          }}
                                        >
                                          {images[4]
                                            ? "Update Image"
                                            : "Upload file"}

                                          <VisuallyHiddenInput
                                            type="file"
                                            ref={fileInputRef}
                                          />
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {data.school_name?.length !== 0 ||
                            data.school_place?.length !== 0 ||
                            data.year_of_passing?.length !== 0 ||
                            selectedEducation.includes("OTHER") ? (
                              <>
                                <div className="row">
                                  <div
                                    className="col-12 educationDetailsHead"
                                    style={{
                                      marginTop: "30px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "19px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      OTHER
                                    </label>
                                    {state.NumberCounts.Editable !== 1 ? (
                                      // ||
                                      // (state.ClientBranchIDs.SUBROLE == 3
                                      <p
                                        onClick={() => {
                                          handleRemoveEducation(
                                            "OTHER",
                                            "other_",
                                          );
                                          setData({
                                            ...data,
                                            school_name: "",
                                            school_place: "",
                                            standard: "",
                                            year_of_passing: "",
                                          });
                                        }}
                                      >
                                        x
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className="row">
                                  {OtherBasicInfo.map((row, rowIndex) => (
                                    <>
                                      {row.map((input, inputIndex) => {
                                        //  console.log(
                                        //    inputIndex,
                                        //    "jalsfdjlskdfjs"
                                        //  );

                                        return (
                                          <>
                                            <div
                                              // className="col mt-3"
                                              className="col-sm-3 mt-4"
                                              key={inputIndex}
                                            >
                                              <label
                                                htmlFor={`validationCustom${
                                                  inputIndex + 1
                                                }`}
                                                className="form-label"
                                              >
                                                {input.label}
                                                {(!isAthena ||
                                                  input.name !==
                                                    "school_name") && (
                                                  <span style={{ color: "red" }}>
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                type={
                                                  // rowIndex === 1 && inputIndex === 0
                                                  input.label ==
                                                  "Year of passout"
                                                    ? // ? "number"
                                                      "number"
                                                    : "text"
                                                }
                                                step="1"
                                                ref={inputRef}
                                                onKeyDown={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year of passout"
                                                  ) {
                                                    preventZoom(evt);
                                                  }
                                                }}
                                                onPaste={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year of passout"
                                                  ) {
                                                    handlePaste(evt); // Add your handlePaste logic here
                                                  }
                                                }}
                                                onWheel={(evt) => {
                                                  if (
                                                    input.label ==
                                                    "Year of passout"
                                                  ) {
                                                    preventZoom(evt); // Add your preventZoom logic here
                                                  }
                                                }}
                                                className="form-control"
                                                // required={
                                                //   input.label === "Institute Place"
                                                // }
                                                disabled={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                autoComplete="off"
                                                value={input.value}
                                                name={input.name}
                                                // readOnly
                                                readOnly={
                                                  state.NumberCounts.Editable ==
                                                    1 &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE != 3
                                                    ? true
                                                    : false
                                                }
                                                // max={
                                                //   input.label ===
                                                //   "Year Of Passing"
                                                //     ? "4"
                                                //     : undefined
                                                // }
                                                // maxLength={
                                                //   rowIndex === 1 &&
                                                //   inputIndex === 0
                                                //     ? "4"
                                                //     : undefined
                                                // }

                                                onChange={(e) => {
                                                  // HandleChanges(e);

                                                  const value = e.target.value;
                                                  if (
                                                    input.label ===
                                                      "Year of passout" &&
                                                    value.length > 4
                                                  ) {
                                                    // toast.error(
                                                    //   "Year of Passing cannot exceed 4 characters",
                                                    //   {
                                                    //     position:
                                                    //       toast.POSITION.TOP_RIGHT,
                                                    //   }
                                                    // );
                                                  } else {
                                                    // Update the input value as needed

                                                    HandleChanges(e);

                                                    switch (input.name) {
                                                      case "school_name":
                                                        setSchoolName(value);
                                                        break;
                                                      case "school_place":
                                                        setSchoolPlace(value);
                                                        break;
                                                      case "year_of_passing":
                                                        setYearOfPassing(value);
                                                        break;
                                                      case "standard":
                                                        setStanderr(value);
                                                        break;
                                                      default:
                                                        break;
                                                    }

                                                    // Clear the error for the specific field
                                                    setOtherErr((prev) => ({
                                                      ...prev,
                                                      [input.name]: "",
                                                    }));
                                                  }
                                                }}
                                              />
                                              {otherErr[input.name] && (
                                                <span style={{ color: "red" }}>
                                                  {otherErr[input.name]}
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        );
                                      })}
                                    </>
                                  ))}
                                </div>
                              </>
                            ) : null}
                          </div>
                        </>
                      ) : null}
                      {(state.NumberCounts.Editable == 2 ||
                        state.ClientBranchIDs.SUBROLE == 3) &&
                      state.NumberCounts.EmployeeFormFIll == true ? (
                        <>
                          <div
                            className="RoleButton"
                            style={{
                              display: "flex",
                              gap: "15px",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              marginBottom: "15px",
                              padding: "0px 10px ",
                            }}
                          >
                            <button
                              class="btn ButtonCSS"
                              style={{ color: "#ffff", background: "#F26239" }}
                              onClick={(e) => {
                                dispatch(SetActiveTabs(4));
                                // const payload ={
                                //   userid:state.ClientBranchIDs.EmployeeDetailsProfile,
                                //   type:"BIF"
                                // }
                                // dispatch(setPreviousDataFetchActions(payload))
                              }}
                            >
                              Previous
                            </button>

                            <button
                              class="btn ButtonCSS"
                              style={{ color: "#ffff", background: "#F26239" }}
                              onClick={(e) => {
                                HandleNext(e);
                              }}
                            >
                              Save & Continue
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          {(state.NumberCounts.Editable == 1 &&
                            state.SideBarFiles.UserEmailID ==
                              "admin@gmail.com") ||
                          state.SideBarFiles.UserEmailID == "adminit@uds.in" ||
                          state.SideBarFiles.UserEmailID ==
                            "codoid@gmail.com" ||
                          state.SideBarFiles.UserEmailID == "admin@uds.in" ? (
                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                marginBottom: "15px",
                                padding: "0px 10px ",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#F26239",
                                }}
                                onClick={(e) => {
                                  dispatch(SetActiveTabs(4));
                                  // const payload ={
                                  //   userid:state.ClientBranchIDs.EmployeeDetailsProfile,
                                  //   type:"BIF"
                                  // }
                                  // dispatch(setPreviousDataFetchActions(payload))
                                }}
                              >
                                Previous
                              </button>

                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#F26239",
                                }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={Educatiobnfiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default EducationDetails;
